import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IonicComponentsModule } from "src/components/ionic-components.module";
import { TranslatePipe, TranslateDirective } from "@ngx-translate/core";

/**
 * Requirements of a new password shown as a checklist under the field: each one turns green
 * with a tick as soon as the typed password meets it.
 */
@Component({
  selector: "app-password-criteria",
  templateUrl: "./password-criteria.component.html",
  styleUrls: ["./password-criteria.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
  imports: [IonicComponentsModule, TranslatePipe, TranslateDirective],
})
export class PasswordCriteriaComponent {
  /** Password typed so far */
  @Input() password: string = "";

  /** Requirements with their label and whether the password meets them */
  public get criteria(): Array<{ label: string; met: boolean }> {
    const password = this.password ?? "";
    return [
      { label: "dictionary.criteriapasswordLen", met: password.length >= 8 },
      { label: "dictionary.criteriapasswordUpper", met: /[A-Z]/.test(password) },
      { label: "dictionary.criteriapasswordLower", met: /[a-z]/.test(password) },
      { label: "dictionary.criteriapasswordSpecialNumber", met: /[0-9]/.test(password) },
      { label: "dictionary.criteriapasswordSpecialChars", met: /\W|_/.test(password) },
    ];
  }
}
